import { LucideIcon } from "lucide-react";
import {
  Search,
  ChartArea,
  MousePointer2,
  Heart,
  HandHeart,
} from "lucide-react";
// @ts-ignore
import uniImg from "../assets/images/AIMST.png";
// @ts-ignore
import countryImg from "../assets/images/aus-flag-corner.svg";

export interface CountryCardProps {
  image: string;
  title: string;
  desc: string;
  link: string;
}

export const CountryCardData: CountryCardProps[] = [
  {
    image: countryImg,
    title: "Study in Australia",
    desc: "Enquire here so that our education counsellors can advise you on our complete list of partner universities.",
    link: "/",
  },
  {
    image: countryImg,
    title: "Study in Australia",
    desc: "Enquire here so that our education counsellors can advise you.",
    link: "/",
  },
];
export interface UniCardProps {
  logo: string;
  uniName: string;
  uniLink: string;
  uniLocation: string;
  uniStates: string[];
  courseCount: number;
  courseLink: string;
  offerCount: number;
  offerLink: string;
}
export interface SidebarItemProps {
  Logo: LucideIcon;
  title: string;
  desc: string;
  className?: string;
}

export const SidebarItemData: SidebarItemProps[] = [
  {
    Logo: Search,
    title: "DISCOVER AND SAVE MORE",
    desc: "Find suitable courses & scholarships instantly with Pathway Match",
  },
  {
    Logo: ChartArea,
    title: "ANALYSE BEST OPTIONS",
    desc: "Make the best choice with insights from our professional counsellors",
  },
  {
    Logo: MousePointer2,
    title: "EASILY APPLY ONLINE",
    desc: "Application of course & scholarship handled by us fully online",
  },
  {
    Logo: Heart,
    title: "STUDENTS LOVE IT",
    desc: "Our students give us 4.9/5 on Google and 5.0/5 on Facebook reviews",
  },
  {
    Logo: HandHeart,
    title: "ALL SERVICES FREE!",
    desc: "It is paid for by universities when you apply through us",
  },
];
